import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react";
import { RiCloseCircleLine, RiSearch2Line } from "@remixicon/react";
import { useCallback, useState } from "react";
import { debounce } from "../../utils/helperFunction";

interface SearchInputProps extends InputProps {
  inputRef?: any;
  placeholder?: string;
  groupPaddingX?: number;
  onConfirm: (inputValue: string) => void;
}

const SearchInput = ({
  inputRef,
  placeholder = "Cari...",
  boxSize,
  groupPaddingX,
  onConfirm,
  ...rest
}: SearchInputProps) => {
  const [data, setData] = useState<string>("");

  const handleChange = (e: any) => {
    setData(e.target.value);
    debouncedSearch(e.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((query: string) => {
      onConfirm(query);
    }, 1000),
    [onConfirm] // Dependency array ensures the debounce updates if onConfirm changes
  );

  const reset = () => {
    setData("");
    onConfirm("");
  };

  return (
    <InputGroup size={["sm", null, "md"]} w={"100%"}>
      <InputLeftElement
        pointerEvents="none"
        height="100%"
        alignItems="center"
        paddingLeft={groupPaddingX}
      >
        <Icon as={RiSearch2Line} boxSize={boxSize} />
      </InputLeftElement>
      <Input
        ref={inputRef}
        type="text"
        value={data}
        onChange={handleChange}
        placeholder={placeholder}
        {...rest}
      />

      <InputRightElement
        height="100%"
        alignItems="center"
        paddingRight={groupPaddingX}
      >
        {data && (
          <IconButton
            size={["sm", null, "md"]}
            variant="ghost"
            icon={<Icon as={RiCloseCircleLine} boxSize={boxSize} />}
            aria-label="Reset input"
            _hover={{ bg: "transparent" }}
            onClick={reset}
          />
        )}
      </InputRightElement>
    </InputGroup>
  );
};

export default SearchInput;
